import axios from 'axios'
import configs from '../local_config'
import { setHeaderAuth } from '@/utils'

const API = configs.API
const HTTP  = configs.HTTP_API
axios.defaults.baseURL = HTTP + '//' + API + '/api/'
axios.defaults.timeout = 900000
setHeaderAuth()

export function authenticate (data) {
    return axios.post('auth/login', data)
}

export function contactRecoverPassword (data) {
    return axios.post('auth/recoverPassword', data)
}

export function contactRegister (data) {
    return axios.post('contact/register', data)
}

export function comments (data) {
    return axios.post('comments', data)
}

export function postContact (data) {
    return axios.post('meetings/contact', data)
}

export function postBusinessAdvice (data) {
    return axios.post('meetings/business-advice', data)
}
export function getPrefix(){
    return axios.get('ubigeo/countries')
}

export function postClaim(data){
    return axios.post('claims-book', data)
}

export function getDepartments(){
    return axios.get('ubigeo/departaments')
}

export function getProvinces(data){
    //let url = builderUserUrl(`ubigeo/departaments/${data}`)
    return axios.get(`ubigeo/departaments/${data}`)
}

export function getDistricts(data){
    return axios.get(`ubigeo/provinces/${data}`)
}

export function getDocumentsType(){
    return axios.get('document-types')
}

export function setPassword(data){
    return axios.post('auth-clients/recover-password', data)
}

export function getBusiness () {
    return axios.get('business-landing/getBusinessLogosForLandingPage')
}
